import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { authService } from '../services/api';
import { useAuth } from '../App';

// Opened from the invite or reset email: the student chooses their own password
export default function SetPassword() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const isReset = params.get('reset') === '1';
  const [form, setForm] = useState({ password: '', confirm: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password.length < 8) return setError('Password must be at least 8 characters.');
    if (form.password !== form.confirm) return setError('The two passwords do not match.');
    setLoading(true);
    try {
      const data = await authService.setPassword({ token, password: form.password });
      login(data);
      navigate('/hub');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-box">
        <h2>{isReset ? 'Choose a new password' : 'Welcome to MK Classes'}</h2>
        <p className="auth-subtitle">{isReset ? 'Enter your new password below.' : 'Set a password for your account to get started.'}</p>

        {!token && <div className="error-msg">This link is missing its code. Open the link from your email again.</div>}
        {error && <div className="error-msg">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>New password (8+ characters)</label>
            <input type="password" autoComplete="new-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required />
          </div>
          <div className="form-group">
            <label>Repeat password</label>
            <input type="password" autoComplete="new-password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} required />
          </div>
          <button type="submit" className="btn-primary" disabled={loading || !token}>
            {loading ? 'Saving...' : 'Save password and log in'}
          </button>
        </form>

        <p className="auth-switch">
          Link expired? <Link to="/forgot-password">Get a new link</Link>
        </p>
      </div>
    </div>
  );
}
